import { FormikAutocomplete } from "@poseidon/ui/components/form/FormikAutocomplete";
import { Field } from "formik";

export const DocumentTypeField = ({ label, name, disabled, ...props }) => {
  return (
    <Field
      component={FormikAutocomplete}
      fullWidth={true}
      label={label}
      name={name}
      options={[
        { label: "Passport", id: "passport" },
        { label: "Driving Licence", id: "driving_licence" },
      ]}
      margin="none"
      disabled={disabled}
      {...props}
    />
  );
};
